import { put, takeEvery, select } from 'redux-saga/effects';
import { startSubmit, stopSubmit } from 'redux-form';
import { notificationsAdd } from 'virtues-bootstrap';
import { path } from 'ramda';

import { FORM_NAMES } from 'constants/forms';
import {
  uploadTachyReport,
  clearTachyReportData,
  deleteTachyReport,
  setTachyReportData,
} from 'store/actionCreators/newTachyReport';
import {
  requestPostDocumentReferenceFailure,
  requestPostDocumentReference,
  requestDeleteDocumentReference,
} from 'store/actionCreators/documentReference';
import i18n from 'services/i18n';
import { getUniqId } from 'utilities';
import { createSagaRace } from 'utilities/request';
import { getCreatedTachyReportData, getDocumentId } from 'store/selectors/tachyReport';
import { getPatientPageUrlId } from 'store/selectors/router';

export function* handleTachyRepordDelete() {
  const documentId = yield select(getDocumentId);
  yield put(requestDeleteDocumentReference(documentId));
  const { success } = yield createSagaRace(requestDeleteDocumentReference);

  if (success) {
    yield put(clearTachyReportData());
    yield put(
      notificationsAdd({
        id: getUniqId(),
        variant: 'success',
        title: i18n.t('common:requestSuccess'),
        description: i18n.t('common:reports.tachyReport.deletedSuccess'),
      }),
    );
  }
}

export function* handleTachyReportUpload() {
  try {
    yield put(startSubmit(FORM_NAMES.uploadTachyReport));

    const patientId = yield select(getPatientPageUrlId);
    const observationData = yield select(getCreatedTachyReportData(patientId));

    yield put(requestPostDocumentReference({ data: observationData }));

    const { success } = yield createSagaRace(requestPostDocumentReference);

    yield put(stopSubmit(FORM_NAMES.uploadTachyReport));

    if (success) {
      const data = {
        entry: [{ resource: path(['payload', 'response'])(success) }],
      };

      yield put(setTachyReportData(data));

      yield put(
        notificationsAdd({
          id: getUniqId(),
          variant: 'success',
          title: i18n.t('common:requestSuccess'),
          description: i18n.t('common:reports.tachyReport.uploadedSuccess'),
        }),
      );
      return;
    }
  } catch (error) {
    yield put(
      notificationsAdd({
        id: getUniqId(),
        variant: 'danger',
        title: i18n.t('common:requestError'),
        description: error.toString(),
      }),
    );
    yield put(requestPostDocumentReferenceFailure(error));
    yield put(stopSubmit(FORM_NAMES.uploadTachyReport));
  }
}

export default function*() {
  yield takeEvery(deleteTachyReport, handleTachyRepordDelete);
  yield takeEvery(uploadTachyReport, handleTachyReportUpload);
}
